// @see http://m.mlb.com/glossary/statcast/hard-hit-rate
// @see https://www.insiderbaseball.com/blog/2019/03/an_introduction_to_hard_hit_rate_hard_for_offense_and_pitching.html

import { ImperialToSiConversion } from '../enums/index.js';

const mphToMs = ImperialToSiConversion.MPH_MPS.ratio;
const exitSpeedThresholdSI = 95 * mphToMs;

const classifiesAsHardHit = function(hitExitSpeedSI) {
    if (Number.isNaN(hitExitSpeedSI)) {
        return null;
    }

    return hitExitSpeedSI >= exitSpeedThresholdSI;
};

export default classifiesAsHardHit;